import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBchjNM-P8qEFo7VSsKvBlL6LPlp-pJf9w",
  authDomain: "downtoearthguides-com.firebaseapp.com",
  projectId: "downtoearthguides-com",
  storageBucket: "downtoearthguides-com.firebasestorage.app",
  messagingSenderId: "721904390261",
  appId: "1:721904390261:web:d47979ccd7466dd63fa83c"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig); 